export default {
    heading: "Shabnam",
};
